module.exports = __webpack_public_path__ + "img/cate_jta.ba048170.svg";